/*
  Woof&Meow path quiz 3D room (three.js r128). The methods below are copied verbatim from the
  Claude Design prototype (tools/path-quiz/project/Main.dc.html, artifact v20); only the wrapper is new.
  State comes from the shared store (wm-path-quiz-core.js). If WebGL or three.js is missing,
  initThree sets webglFail and the quiz carries on without the room. three.js loads async, so the quiz
  shows first; the scene waits up to about 25 s for it (slow phones) and gives up at once if its
  script tag reports an error.
*/
(function () {
  'use strict';
  class QuizScene {
    constructor(canvas, store) {
      this.cv = canvas;
      this.store = store;
      const m = store.model;
      this.ZONES = m.ZONES; this.TILE = m.TILE; this.TONES = m.TONES; this.SUGGEST = m.SUGGEST;
      this.unsub = store.subscribe(() => this.syncThree());
      this.initThree();
    }
    get state() { return this.store.state; }
    setState(p) { this.store.setState(p); }
    dispose() {
      this.disposed = true;
      if (this.unsub) this.unsub();
      if (this.raf) cancelAnimationFrame(this.raf);
      if (this.three) { this.three.renderer.dispose(); this.cv.removeEventListener('pointerdown', this.onTap); }
      this.three = null;
    }
    zoneAt(x, z) { return this.ZONES.find((zn) => x >= zn.r[0] && x < zn.r[0] + zn.r[2] && z >= zn.r[1] && z < zn.r[1] + zn.r[3]); }
    toggleSpot(id) { this.setState((x) => ({ spots: x.spots.indexOf(id) >= 0 ? x.spots.filter((v) => v !== id) : x.spots.concat(id) })); }
    floorTexture(toneId) {
      const T = window.THREE, t = this.TONES[toneId];
      const W = 1024, H = 1024;
      const c = document.createElement('canvas'); c.width = W; c.height = H;
      const g = c.getContext('2d');
      g.fillStyle = t.hex; g.fillRect(0, 0, W, H);
      let seed = 7; const rnd = () => { seed = (seed * 16807) % 2147483647; return seed / 2147483647; };
      if (t.kind === 'wood') {
        const pw = W / 10 * 0.6;
        for (let x = 0; x < W; x += pw) {
          let y = -rnd() * 300;
          while (y < H) {
            const len = 220 + rnd() * 320;
            g.fillStyle = 'rgba(' + (rnd() > .5 ? '255,255,255,' : '0,0,0,') + (rnd() * 0.06).toFixed(3) + ')';
            g.fillRect(x, y, pw, len);
            g.fillStyle = t.line; g.fillRect(x, y + len - 2, pw, 3);
            y += len;
          }
          g.fillStyle = t.line; g.fillRect(x + pw - 2, 0, 3, H);
        }
      } else {
        const sx = W / 10 * 2, sy = H / 12 * 2;
        for (let x = 0; x < W; x += sx) for (let y = 0; y < H; y += sy) {
          g.fillStyle = 'rgba(0,0,0,' + (rnd() * 0.04).toFixed(3) + ')'; g.fillRect(x, y, sx, sy);
        }
        g.fillStyle = t.line;
        for (let x = 0; x <= W; x += sx) g.fillRect(x - 3, 0, 6, H);
        for (let y = 0; y <= H; y += sy) g.fillRect(0, y - 3, W, 6);
      }
      const tex = new T.CanvasTexture(c);
      tex.generateMipmaps = true; tex.minFilter = T.LinearMipmapLinearFilter; tex.magFilter = T.LinearFilter;
      tex.anisotropy = this.three ? this.three.renderer.capabilities.getMaxAnisotropy() : 8;
      return tex;
    }
    label(text, on) {
      const T = window.THREE;
      // Drawn at 3x and scaled back, so the labels stay sharp on high-density screens.
      const K = 3;
      const c = document.createElement('canvas'); c.width = 320 * K; c.height = 96 * K;
      const g = c.getContext('2d');
      g.scale(K, K);
      g.font = '800 40px Nunito, system-ui, sans-serif';
      const w = Math.min(300, g.measureText(text).width + 56);
      const x = (320 - w) / 2;
      g.fillStyle = on ? '#4A3A30' : '#FFFFFF';
      g.beginPath(); g.moveTo(x + 36, 12); g.arcTo(x + w, 12, x + w, 84, 36); g.arcTo(x + w, 84, x, 84, 36); g.arcTo(x, 84, x, 12, 36); g.arcTo(x, 12, x + w, 12, 36); g.fill();
      g.fillStyle = on ? '#FFFFFF' : '#4A3A30'; g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillText(text, 160, 50);
      const tex = new T.CanvasTexture(c);
      tex.minFilter = T.LinearMipmapLinearFilter; tex.magFilter = T.LinearFilter;
      if (this.three) tex.anisotropy = this.three.renderer.capabilities.getMaxAnisotropy();
      return tex;
    }
    initThree() {
      const T = window.THREE;
      if (!T) { this.tries = (this.tries || 0) + 1; if (this.disposed) return; if (window.__wmThreeFailed || this.tries > 200) { this.setState({ webglFail: true }); return; } setTimeout(() => this.initThree(), 120); return; }
      if (this.three || !this.cv) return;
      let renderer;
      try { renderer = new T.WebGLRenderer({ canvas: this.cv, antialias: true, alpha: true }); }
      catch (e) { this.setState({ webglFail: true }); return; }
      const W = 366, H = 318;
      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 3)); // full sharpness on 3x phones (Mkeo: crystal clear)
      renderer.setSize(W, H, false);
      renderer.shadowMap.enabled = true; renderer.shadowMap.type = T.PCFSoftShadowMap;
      const scene = new T.Scene();
      const fr = 7.4, asp = W / H;
      const cam = new T.OrthographicCamera(-fr * asp, fr * asp, fr, -fr, 0.1, 100);
      scene.add(new T.HemisphereLight(0xffffff, 0xd9bc93, 0.8));
      const sun = new T.DirectionalLight(0xffffff, 0.75);
      sun.position.set(6, 14, 9); sun.castShadow = true; sun.shadow.mapSize.set(2048, 2048); sun.shadow.bias = -0.0006; sun.shadow.normalBias = 0.03;
      Object.assign(sun.shadow.camera, { left: -10, right: 10, top: 10, bottom: -10 });
      scene.add(sun);
      const P = (x, z) => [x - 5, z - 6];
      const pops = []; let popping = false;
      const reg = (m, y) => { if (popping) { m.userData.popAt = pops.length * 45 + 250; m.userData.baseY = y; m.scale.setScalar(0.001); pops.push(m); } return m; };
      const box = (w, h, d, col, x, y, z, rough) => {
        const m = new T.Mesh(new T.BoxGeometry(w, h, d), new T.MeshStandardMaterial({ color: col, roughness: rough == null ? 0.85 : rough }));
        const p = P(x, z); m.position.set(p[0], y, p[1]); m.castShadow = true; m.receiveShadow = true; scene.add(m); return reg(m, y);
      };
      const cyl = (r, h, col, x, y, z, r2) => {
        const m = new T.Mesh(new T.CylinderGeometry(r, r2 == null ? r * 0.9 : r2, h, 24), new T.MeshStandardMaterial({ color: col, roughness: 0.6 }));
        const p = P(x, z); m.position.set(p[0], y, p[1]); m.castShadow = true; m.receiveShadow = true; scene.add(m); return reg(m, y);
      };
      const cone = (r, h, col, x, y, z, seg) => {
        const m = new T.Mesh(new T.ConeGeometry(r, h, seg || 8), new T.MeshStandardMaterial({ color: col, roughness: 0.8 }));
        const p = P(x, z); m.position.set(p[0], y, p[1]); m.castShadow = true; scene.add(m); return reg(m, y);
      };
      const floorMat = new T.MeshStandardMaterial({ map: this.floorTexture(this.state.tone), roughness: 0.9 });
      const floor = new T.Mesh(new T.PlaneGeometry(10, 12), floorMat);
      floor.rotation.x = -Math.PI / 2; floor.receiveShadow = true; scene.add(floor);
      box(10.5, 0.3, 12.5, '#E9DCCB', 5, -0.2, 6);
      box(10.4, 2.5, 0.22, '#DCE6D3', 5, 1.25, -0.11);
      box(0.22, 2.5, 12.2, '#F6EBDD', -0.11, 1.25, 6);
      box(10.5, 0.07, 0.3, '#B9A88F', 5, 2.53, -0.11);
      box(0.3, 0.07, 12.4, '#B9A88F', -0.11, 2.53, 6);
      box(10.2, 0.16, 0.06, '#FFFFFF', 5, 0.08, 0.03);
      box(0.06, 0.16, 12, '#FFFFFF', 0.03, 0.08, 6);
      const sunPatch = new T.Mesh(new T.PlaneGeometry(2.2, 2.4), new T.MeshBasicMaterial({ color: '#FFF3C4', transparent: true, opacity: 0.35 }));
      sunPatch.rotation.x = -Math.PI / 2; sunPatch.position.set(P(2.0, 6.9)[0], 0.02, P(2.0, 6.9)[1]); sunPatch.material.depthWrite = false; scene.add(sunPatch);
      box(0.06, 1.1, 2.0, '#FFFFFF', 0.03, 1.55, 6.9); box(0.05, 0.94, 1.84, '#BFDDEB', 0.05, 1.55, 6.9, 0.2);
      box(0.06, 0.06, 1.84, '#FFFFFF', 0.08, 1.55, 6.9);
      box(0.09, 2.05, 1.8, '#4A3A30', 0.05, 1.03, 10.9); box(0.05, 0.7, 0.9, '#BFDDEB', 0.1, 1.45, 10.9, 0.2);
      box(0.1, 0.08, 0.1, '#DD8A4A', 0.12, 1.0, 10.25);
      popping = true;
      box(3, 0.32, 2, '#8B6F5C', 1.6, 0.16, 0.95); box(2.5, 0.2, 1.5, '#F2D9C3', 1.6, 0.42, 0.95); box(0.9, 0.16, 0.6, '#DD8A4A', 0.7, 0.58, 0.6);
      box(0.95, 0.65, 0.06, '#DD8A4A', 1.1, 1.65, 0.03); box(0.75, 0.48, 0.07, '#FBE4D2', 1.1, 1.65, 0.04);
      box(0.6, 0.8, 0.06, '#2F3E5C', 2.35, 1.75, 0.03); box(0.46, 0.64, 0.07, '#EEF1EA', 2.35, 1.75, 0.04);
      box(1.3, 1.9, 0.5, '#B98F58', 4.0, 0.95, 0.27);
      [['#DD8A4A', 3.55], ['#2F3E5C', 3.8], ['#8FA08A', 4.05], ['#F2D9C3', 4.3]].forEach((b, i) => box(0.2, 0.42, 0.36, b[0], b[1], 0.55 + (i % 2) * 0.62, 0.32));
      box(0.7, 0.1, 0.36, '#4A3A30', 4.15, 1.42, 0.32);
      box(2.6, 1.0, 0.9, '#FAF6F0', 7.7, 0.5, 0.45); box(2.7, 0.08, 1.0, '#4A3A30', 7.7, 1.04, 0.5);
      box(2.6, 0.6, 0.45, '#FAF6F0', 7.7, 2.0, 0.23); box(0.9, 0.14, 0.4, '#2F3E5C', 7.4, 1.18, 0.45);
      box(0.95, 2.15, 0.85, '#E4ECEF', 9.5, 1.08, 0.45); box(0.05, 0.6, 0.05, '#76746F', 9.1, 1.4, 0.9);
      cyl(0.34, 0.2, '#DD8A4A', 9.5, 0.1, 2.2); cyl(0.34, 0.2, '#2F3E5C', 9.5, 0.1, 3.4);
      box(1.4, 0.48, 2.9, '#8FA08A', 0.8, 0.24, 6.9); box(0.36, 0.95, 2.9, '#7E9079', 0.22, 0.48, 6.9);
      box(1.4, 0.7, 0.32, '#7E9079', 0.8, 0.35, 5.3); box(1.4, 0.7, 0.32, '#7E9079', 0.8, 0.35, 8.5);
      box(0.18, 0.5, 0.6, '#DD8A4A', 0.55, 0.72, 6.1); box(0.18, 0.5, 0.6, '#2F3E5C', 0.55, 0.72, 7.6);
      box(1.0, 0.08, 1.5, '#7B5636', 2.6, 0.42, 6.9); box(0.08, 0.38, 0.08, '#7B5636', 2.2, 0.19, 6.3); box(0.08, 0.38, 0.08, '#7B5636', 3.0, 0.19, 7.5);
      box(0.08, 0.38, 0.08, '#7B5636', 2.2, 0.19, 7.5); box(0.08, 0.38, 0.08, '#7B5636', 3.0, 0.19, 6.3);
      cyl(0.16, 0.18, '#FBE4D2', 2.6, 0.55, 6.6);
      cyl(0.05, 1.5, '#4A3A30', 0.6, 0.75, 4.6); cone(0.32, 0.4, '#FBE4D2', 0.6, 1.6, 4.6, 16);
      box(0.16, 1.05, 5.0, '#F6EBDD', 4.85, 0.53, 7.0); box(0.26, 0.06, 5.1, '#B9A88F', 4.85, 1.08, 7.0);
      cyl(0.75, 0.07, '#7B5636', 8.8, 0.78, 8.6, 0.75); cyl(0.09, 0.75, '#4A3A30', 8.8, 0.38, 8.6);
      [[7.85, 8.6, '#DD8A4A', -1, 0], [9.75, 8.6, '#2F3E5C', 1, 0], [8.8, 9.7, '#8FA08A', 0, 1]].forEach((c) => { box(0.5, 0.08, 0.5, c[2], c[0], 0.48, c[1]); box(c[3] ? 0.08 : 0.5, 0.5, c[3] ? 0.5 : 0.08, c[2], c[0] + c[3] * 0.22, 0.75, c[1] + c[4] * 0.22); [[-0.2, -0.2], [0.2, -0.2], [-0.2, 0.2], [0.2, 0.2]].forEach((l) => box(0.06, 0.44, 0.06, '#4A3A30', c[0] + l[0], 0.22, c[1] + l[1])); });
      cyl(0.3, 0.5, '#DD8A4A', 9.5, 0.25, 11.3); cone(0.55, 1.2, '#6F8F5F', 9.5, 1.1, 11.3, 7); cone(0.4, 0.8, '#7FA06C', 9.5, 1.6, 11.3, 7);
      popping = false;

      const tileGeo = new T.BoxGeometry(0.94, 0.1, 0.94); const edgeGeo = new T.EdgesGeometry(tileGeo); const shadows = {};
      const tiles = [], ghosts = {}, pins = {};
      this.ZONES.forEach((zn) => {
        zn.cells.forEach((c, k) => {
          const mat = new T.MeshStandardMaterial({ color: '#C4C4C0', roughness: 0.95, transparent: true, opacity: 0 });
          const m = new T.Mesh(tileGeo, mat); const p = P(c.x + 0.5, c.z + 0.5);
          const edge = new T.LineSegments(edgeGeo, new T.LineBasicMaterial({ color: 0x1d1511, transparent: true, opacity: 0 })); m.add(edge); m.userData.edge = edge;
          m.position.set(p[0], 2.4, p[1]); m.visible = false; m.receiveShadow = true; m.castShadow = true; scene.add(m);
          tiles.push({ mesh: m, zone: zn.id, k: k, cell: c, on: false, p: 0, start: 0 });
        });
        const a = P(zn.r[0], zn.r[1]), b = P(zn.r[0] + zn.r[2], zn.r[1] + zn.r[3]);
        const pts = [new T.Vector3(a[0] + 0.05, 0.03, a[1] + 0.05), new T.Vector3(b[0] - 0.05, 0.03, a[1] + 0.05), new T.Vector3(b[0] - 0.05, 0.03, b[1] - 0.05), new T.Vector3(a[0] + 0.05, 0.03, b[1] - 0.05)];
        const line = new T.LineLoop(new T.BufferGeometry().setFromPoints(pts), new T.LineDashedMaterial({ color: 0x4a3a30, dashSize: 0.28, gapSize: 0.18 }));
        line.computeLineDistances(); line.visible = false; scene.add(line); ghosts[zn.id] = line;
        const fill = new T.Mesh(new T.PlaneGeometry(zn.r[2] - 0.1, zn.r[3] - 0.1), new T.MeshBasicMaterial({ color: 0xffffff, transparent: true, opacity: 0.35, depthWrite: false }));
        fill.rotation.x = -Math.PI / 2; const fc = P(zn.r[0] + zn.r[2] / 2, zn.r[1] + zn.r[3] / 2); fill.position.set(fc[0], 0.025, fc[1]); fill.visible = false; scene.add(fill); line.userData.fill = fill;
        const sh = new T.Mesh(new T.PlaneGeometry(zn.r[2] + 0.35, zn.r[3] + 0.35), new T.MeshBasicMaterial({ color: 0x1d1511, transparent: true, opacity: 0, depthWrite: false }));
        sh.rotation.x = -Math.PI / 2; sh.position.set(fc[0], 0.015, fc[1]); scene.add(sh); shadows[zn.id] = sh;
        const spr = new T.Sprite(new T.SpriteMaterial({ map: this.label(zn.pin, false), depthTest: false }));
        const cp = P(zn.r[0] + zn.r[2] / 2, zn.r[1] + zn.r[3] / 2); spr.position.set(cp[0], 1.5, cp[1]); spr.scale.set(2.6, 0.78, 1); spr.renderOrder = 10; spr.visible = false;
        spr.userData = { on: false }; scene.add(spr); pins[zn.id] = spr;
      });

      const dog = new T.Group();
      const fur = new T.MeshStandardMaterial({ color: '#C8955E', roughness: 0.9 });
      const dark = new T.MeshStandardMaterial({ color: '#8E5F36', roughness: 0.9 });
      const ink = new T.MeshStandardMaterial({ color: '#1D1511', roughness: 0.4 });
      const part = (g, w, h, d, mat, x, y, z, parent) => { const m = new T.Mesh(new T.BoxGeometry(w, h, d), mat); m.position.set(x, y, z); m.castShadow = true; (parent || dog).add(m); return m; };
      const body = new T.Group(); dog.add(body);
      part(null, 0.95, 0.42, 0.44, fur, 0, 0.66, 0, body);
      const head = new T.Group(); head.position.set(0.55, 0.9, 0); body.add(head);
      part(null, 0.42, 0.38, 0.38, fur, 0, 0, 0, head);
      part(null, 0.24, 0.17, 0.24, fur, 0.28, -0.07, 0, head);
      part(null, 0.07, 0.07, 0.09, ink, 0.41, -0.03, 0, head);
      part(null, 0.04, 0.05, 0.05, ink, 0.2, 0.07, 0.11, head); part(null, 0.04, 0.05, 0.05, ink, 0.2, 0.07, -0.11, head);
      const earL = part(null, 0.14, 0.26, 0.07, dark, -0.02, 0.0, 0.22, head); earL.rotation.x = 0.25;
      const earR = part(null, 0.14, 0.26, 0.07, dark, -0.02, 0.0, -0.22, head); earR.rotation.x = -0.25;
      const tail = new T.Group(); tail.position.set(-0.48, 0.78, 0); body.add(tail);
      const tl = part(null, 0.34, 0.08, 0.08, fur, -0.15, 0, 0, tail); tail.rotation.z = -0.6;
      const legs = [];
      [[0.32, 0.15], [0.32, -0.15], [-0.32, 0.15], [-0.32, -0.15]].forEach((xz, i) => {
        const piv = new T.Group(); piv.position.set(xz[0], 0.48, xz[1]); body.add(piv);
        part(null, 0.12, 0.46, 0.12, i < 2 ? fur : fur, 0, -0.23, 0, piv);
        part(null, 0.14, 0.06, 0.16, dark, 0.02, -0.45, 0, piv);
        legs.push(piv);
      });
      scene.add(dog);

      const spareGeo = new T.BoxGeometry(0.9, 0.06, 0.9); const spareStack = [];
      for (let i = 0; i < 10; i++) {
        const m = new T.Mesh(spareGeo, new T.MeshStandardMaterial({ color: '#C4C4C0', roughness: 0.95 }));
        const sp = P(4.35, 1.25); m.position.set(sp[0], 0.04 + i * 0.065, sp[1]); m.rotation.y = (i % 3 - 1) * 0.08; m.castShadow = true; m.visible = false;
        m.add(new T.LineSegments(new T.EdgesGeometry(spareGeo), new T.LineBasicMaterial({ color: 0x1d1511, transparent: true, opacity: 0.5 })));
        scene.add(m); spareStack.push(m);
      }
      const spareLabel = new T.Sprite(new T.SpriteMaterial({ map: this.label('Spares', true), depthTest: false }));
      const slp = P(4.35, 1.25); spareLabel.position.set(slp[0], 1.35, slp[1]); spareLabel.scale.set(2.2, 0.66, 1); spareLabel.renderOrder = 10; spareLabel.visible = false; scene.add(spareLabel);
      const bits = [];
      const bitGeo = new T.BoxGeometry(0.2, 0.2, 0.04);
      for (let i = 0; i < 140; i++) {
        const m = new T.Mesh(bitGeo, new T.MeshBasicMaterial({ color: '#FFFFFF', transparent: true, opacity: 0 }));
        m.visible = false; scene.add(m); bits.push({ mesh: m, life: 0, max: 1, vx: 0, vy: 0, vz: 0 });
      }

      this.three = { spareStack, spareLabel, renderer, scene, cam, floor, floorMat, tiles, ghosts, pins, shadows, dog, body, head, tail, legs, pops, bits, bitNext: 0, born: performance.now(), lastStep: -1, zoom: 1, last: 0, dist: 0, phase: 0, yaw: 0, scale: 0.95, tone: this.state.tone, ray: new T.Raycaster() };
      this.onTap = (ev) => {
        if (this.state.step !== 5 || !this.three) return;
        const rc = this.cv.getBoundingClientRect();
        const v = new T.Vector2(((ev.clientX - rc.left) / rc.width) * 2 - 1, -((ev.clientY - rc.top) / rc.height) * 2 + 1);
        this.three.ray.setFromCamera(v, cam);
        const hit = this.three.ray.intersectObjects([floor].concat(tiles.map((t) => t.mesh)))[0];
        if (!hit) return;
        const zn = this.zoneAt(Math.floor(hit.point.x + 5), Math.floor(hit.point.z + 6));
        const hx = hit.point.x + 5, hz = hit.point.z + 6;
        let best = zn, bd = 1.5;
        if (!best) this.ZONES.forEach((z) => { const dx = Math.max(z.r[0] - hx, 0, hx - (z.r[0] + z.r[2])); const dz = Math.max(z.r[1] - hz, 0, hz - (z.r[1] + z.r[3])); const d = Math.hypot(dx, dz); if (d < bd) { bd = d; best = z; } });
        if (best) this.toggleSpot(best.id);
      };
      this.cv.addEventListener('pointerdown', this.onTap);
      this.syncThree();
      const tick = (now) => { if (this.disposed || !this.three) return; this.frame(now); this.raf = requestAnimationFrame(tick); };
      this.raf = requestAnimationFrame(tick);
    }
    tileHex(t) {
      const s = this.state; const A = this.TILE[s.mix[0]] || this.TILE.lgrey; const B = this.TILE[s.mix[1]] || A;
      if (s.pattern === 'solid' || !s.mix[1]) return A.hex;
      const zn = this.ZONES.find((z) => z.id === t.zone);
      const along = zn.r[2] > zn.r[3] ? t.cell.i : t.cell.j;
      const alt = s.pattern === 'stripes' ? along % 2 : (t.cell.x + t.cell.z) % 2;
      return alt ? B.hex : A.hex;
    }
    syncThree() {
      const th = this.three; if (!th) return;
      const s = this.state, now = performance.now();
      th.tiles.forEach((t) => {
        const on = s.spots.indexOf(t.zone) >= 0 && s.step >= 5;
        if (on !== t.on) { t.on = on; t.start = now + (on ? t.k * 30 : t.k * 8); }
        t.mesh.material.color.set(this.tileHex(t));
      });
      this.ZONES.forEach((zn) => {
        const on = s.spots.indexOf(zn.id) >= 0;
        th.ghosts[zn.id].visible = s.step === 5 && !on; th.ghosts[zn.id].userData.fill.visible = s.step === 5 && !on;
        th.shadows[zn.id].userData.on = on && s.step >= 5;
        const pin = th.pins[zn.id];
        pin.visible = s.step >= 5 && s.step <= 12;
        if (pin.userData.on !== on) { pin.material.map.dispose(); pin.material.map = this.label(zn.pin, on); pin.material.needsUpdate = true; pin.userData.on = on; }
      });
      if (th.tone !== s.tone) { th.floorMat.map.dispose(); th.floorMat.map = this.floorTexture(s.tone); th.floorMat.needsUpdate = true; th.tone = s.tone; }
      th.targetScale = 0.95;
      th.route = this.route();
      if ((s.step === 12 && th.lastStep !== 12) || (s.unlocked && !th.wasUnlocked)) {
        th.wasUnlocked = !!s.unlocked;
        const cols = [this.tileHex({ zone: 'hall', cell: { x: 0, z: 0, i: 0, j: 0 } }), this.tileHex({ zone: 'hall', cell: { x: 1, z: 0, i: 0, j: 1 } }), '#DD8A4A', '#FBE4D2', '#8FA08A'];
        for (let i = 0; i < 110; i++) {
          const a = Math.random() * Math.PI * 2, sp = 2 + Math.random() * 5;
          this.spawn((Math.random() - 0.5) * 6, 3 + Math.random() * 2, (Math.random() - 0.5) * 6, cols[i % cols.length], Math.cos(a) * sp * 0.6, 5 + Math.random() * 5, Math.sin(a) * sp * 0.6, 1.6 + Math.random());
        }
      }
      const laid = this.ZONES.filter((z) => s.spots.indexOf(z.id) >= 0).reduce((n, z) => n + z.cells.length, 0);
      const recN = laid >= 50 ? 60 : ([10, 20, 30, 50].find((n) => n >= laid) || 50);
      const nSpare = s.step >= 5 && laid ? recN - laid : 0;
      th.spareStack.forEach((m, i) => { m.visible = i < nSpare; m.material.color.set(this.tileHex({ zone: 'hall', cell: { x: i, z: 0, i: i, j: i } })); });
      th.spareLabel.visible = nSpare > 0 && s.step <= 12;
      if (!s.unlocked) th.wasUnlocked = false;
      th.lastStep = s.step;
    }
    spawn(x, y, z, col, vx, vy, vz, max) {
      const th = this.three; const b = th.bits[th.bitNext]; th.bitNext = (th.bitNext + 1) % th.bits.length;
      b.mesh.position.set(x, y, z); b.mesh.material.color.set(col); b.mesh.visible = true; b.mesh.rotation.set(Math.random() * 3, Math.random() * 3, 0);
      b.vx = vx; b.vy = vy; b.vz = vz; b.life = 0; b.max = max;
    }
    route() {
      const s = this.state; const has = (id) => s.spots.indexOf(id) >= 0;
      if (s.step < 12) return [[6, 3.4], [6, 9.8]];
      const r = [];
      if (has('bed')) r.push([2.4, 3.0]);
      r.push([6, 3.0]);
      if (has('bowls')) { r.push([7.9, 3.0]); r.push([7.9, 5.0]); r.push([6, 5.0]); }
      if (has('hall') || has('door')) r.push([6, 10.9]);
      if (has('door')) r.push([1.4, 10.9]);
      return r.length > 1 ? r : [[6, 3.4], [6, 9.8]];
    }
    frame(now) {
      const th = this.three; const s = this.state;
      const dt = Math.min(0.05, (now - (th.last || now)) / 1000); th.last = now; const t = now / 1000;
      const ch = Math.round(this.cv.clientHeight || 318), cw = Math.round(this.cv.clientWidth || 366);
      if (ch > 40 && cw > 40 && (ch !== th.h || cw !== th.w)) {
        th.h = ch; th.w = cw; th.renderer.setSize(cw, ch, false);
        const half = Math.max(7.6, 6.4 * cw / ch), vh = half * ch / cw; th.camY = 15 + Math.max(0, Math.min(10, (ch / cw - 0.85) * 22));
        th.cam.left = -half; th.cam.right = half; th.cam.top = vh; th.cam.bottom = -vh; th.cam.updateProjectionMatrix();
      }
      th.tiles.forEach((tl) => {
        const target = tl.on ? 1 : 0;
        if (tl.p !== target && now >= tl.start) tl.p = Math.max(0, Math.min(1, tl.p + (target > tl.p ? 1 : -1) * dt * 2.4));
        const e = 1 - Math.pow(1 - tl.p, 4);
        tl.mesh.visible = tl.p > 0.001;
        tl.mesh.position.y = 0.035 + (1 - e) * 2.4;
        tl.mesh.rotation.y = (1 - e) * 0.8;
        tl.mesh.material.opacity = Math.min(1, tl.p * 1.8); tl.mesh.userData.edge.material.opacity = Math.min(0.55, tl.p * 0.8);
        if (tl.on && tl.p >= 0.97 && !tl.landed) {
          tl.landed = true;
          for (let i = 0; i < 3; i++) { const a = Math.random() * Math.PI * 2; this.spawn(tl.mesh.position.x, 0.1, tl.mesh.position.z, '#FFFFFF', Math.cos(a) * 1.2, 1 + Math.random(), Math.sin(a) * 1.2, 0.45); }
        }
        if (!tl.on) tl.landed = false;
      });
      Object.keys(th.shadows).forEach((id) => { const m = th.shadows[id]; const tgt = m.userData.on ? 0.22 : 0; m.material.opacity += (tgt - m.material.opacity) * Math.min(1, dt * 5); });
      Object.keys(th.ghosts).forEach((id) => { const f = th.ghosts[id].userData.fill; if (f.visible) f.material.opacity = 0.25 + Math.sin(t * 3) * 0.15; });
      th.pops.forEach((m) => {
        const k = Math.max(0, Math.min(1, (now - th.born - m.userData.popAt) / 450));
        const c1 = 1.70158, c3 = c1 + 1;
        const e2 = k === 0 ? 0.001 : 1 + c3 * Math.pow(k - 1, 3) + c1 * Math.pow(k - 1, 2);
        m.scale.setScalar(Math.max(0.001, e2));
      });
      th.bits.forEach((b) => {
        if (!b.mesh.visible) return;
        b.life += dt; const k = b.life / b.max;
        if (k >= 1) { b.mesh.visible = false; return; }
        b.vy -= 14 * dt;
        b.mesh.position.x += b.vx * dt; b.mesh.position.y = Math.max(0.06, b.mesh.position.y + b.vy * dt); b.mesh.position.z += b.vz * dt;
        b.mesh.rotation.x += dt * 6; b.mesh.rotation.y += dt * 4;
        b.mesh.material.opacity = 1 - k;
      });
      const pts = th.route; let L = 0; const seg = [];
      for (let i = 1; i < pts.length; i++) { const d = Math.hypot(pts[i][0] - pts[i - 1][0], pts[i][1] - pts[i - 1][1]); seg.push(d); L += d; }
      const cx = Math.floor(th.dog.position.x + 5), cz = Math.floor(th.dog.position.z + 6);
      const zn = this.zoneAt(cx, cz);
      const onTile = !!(zn && s.spots.indexOf(zn.id) >= 0 && s.step >= 5);
      const bare = !onTile && s.step < 12;
      const skidT = t % 1.7; const skid = bare && skidT < 0.9 ? Math.sin(skidT / 0.9 * Math.PI) : 0;
      const speed = onTile ? 1.5 : 0.8;
      th.dist += dt * speed * (1 - skid * 0.7);
      let u = L ? th.dist % (2 * L) : 0; if (u > L) u = 2 * L - u;
      let acc = 0, x = pts[0][0], z = pts[0][1];
      for (let i = 0; i < seg.length; i++) {
        if (u <= acc + seg[i] || i === seg.length - 1) { const f = seg[i] ? Math.min(1, (u - acc) / seg[i]) : 0; x = pts[i][0] + (pts[i + 1][0] - pts[i][0]) * f; z = pts[i][1] + (pts[i + 1][1] - pts[i][1]) * f; break; }
        acc += seg[i];
      }
      const slide = skid * 0.22 * Math.sin(t * 7);
      const nx = x - 5 + Math.sin(th.yaw) * slide, nz = z - 6 + Math.cos(th.yaw) * slide;
      const dx = (x - 5) - (th.px == null ? x - 5 : th.px), dz = (z - 6) - (th.pz == null ? z - 6 : th.pz);
      th.px = x - 5; th.pz = z - 6;
      if (Math.hypot(dx, dz) > 0.0005) {
        const want = Math.atan2(-dz, dx);
        let diff = want - th.yaw; while (diff > Math.PI) diff -= 2 * Math.PI; while (diff < -Math.PI) diff += 2 * Math.PI;
        th.yaw += diff * Math.min(1, dt * 8);
      }
      th.dog.position.set(nx, 0, nz);
      th.dog.rotation.y = th.yaw + (bare ? Math.sin(t * 6) * 0.08 + skid * 0.25 * Math.sin(t * 4) : 0);
      th.scale += ((th.targetScale || 0.95) - th.scale) * Math.min(1, dt * 4);
      th.dog.scale.setScalar(th.scale);
      th.phase += dt * speed * (bare ? 9 : 7);
      const sw = Math.sin(th.phase) * (bare ? 0.3 : 0.5) + (bare ? Math.sin(th.phase * 2.3) * 0.12 : 0);
      th.legs[0].rotation.z = sw; th.legs[3].rotation.z = sw; th.legs[1].rotation.z = -sw; th.legs[2].rotation.z = -sw;
      const spl = skid * 0.9 + (bare ? 0.12 : 0);
      th.legs[0].rotation.x = spl; th.legs[2].rotation.x = spl; th.legs[1].rotation.x = -spl; th.legs[3].rotation.x = -spl;
      th.body.position.y = -skid * 0.16 + Math.abs(Math.sin(th.phase)) * (bare ? 0.015 : 0.03);
      th.body.rotation.x = Math.sin(t * 9) * skid * 0.25 + (bare ? Math.sin(t * 5) * 0.05 : 0);
      th.body.rotation.z = bare ? skid * 0.12 : 0;
      th.tail.rotation.z = bare ? -1.0 : -0.5;
      th.tail.rotation.y = Math.sin(t * (onTile ? 12 : 3)) * (onTile ? 0.6 : 0.25);
      th.head.rotation.z = skid * 0.25 + (bare ? -0.08 : 0);
      let a = Math.PI / 4;
      if (s.step >= 12) a += Math.sin(t * 0.35) * 0.5;
      else if (s.step === 0) a += Math.sin(t * 0.45) * 0.3;
      th.cam.position.set(Math.sin(a) * 20, th.camY || 15, Math.cos(a) * 20);
      th.cam.lookAt(0, 0.4, 0);
      const zt = s.step >= 12 ? 1.04 : 1;
      th.zoom += (zt - th.zoom) * Math.min(1, dt * 3);
      if (Math.abs(th.cam.zoom - th.zoom) > 0.0005) { th.cam.zoom = th.zoom; th.cam.updateProjectionMatrix(); }
      th.renderer.render(th.scene, th.cam);
    }
  }
  window.WMQuiz = window.WMQuiz || {};
  window.WMQuiz.scene = (canvas, store) => { const s = new QuizScene(canvas, store); window.WMQuiz.lastScene = s; return s; };
})();
